module.exports = __webpack_public_path__ + "img/sly1.4f5e35af.jpg";